import { render, staticRenderFns } from "./FamousFormReadWeb.vue?vue&type=template&id=04232c51&"
import script from "./FamousFormReadWeb.vue?vue&type=script&lang=js&"
export * from "./FamousFormReadWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports